import React from "react";
import "./Footer.css";
import logo from "../../Assets/images/logo.png"; 
import { FaFacebookF } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaPinterest } from "react-icons/fa";

import { Link } from "react-router-dom";

const Footer = () => {
 
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const getCurrentYear = () => new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container footer__container">
        <div className="footer_left">
          <div className="footer_logo_container">
            <img src={logo} alt="" />
          </div>

          <p>1418 River Drive, Suite 35 Cottonhall, CA 9622 United States</p>

          <div className="footer_address">
            <strong> sale@uomo.com </strong>
            <strong> +1 246-345-0695 </strong>
          </div>

          <div className="social_links">
            <FaFacebookF />
            <FaXTwitter />
            <FaInstagram />
            <FaYoutube />
            <FaPinterest />
          </div>
        </div>

        <div className="footer_content">
          <h5>Company</h5>
          <div className="links_container">
            <ul onClick={scrollToTop}>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/about">Career</Link>
              </li>
              <li>
                <Link to="*">Affilates</Link>
              </li>
              <li>
                <Link to="/blog">Blog</Link>
              </li>
              <li>
                <Link to="/contact">Contact Us</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer_content">
          <h5>Shop</h5>
          <div className="links_container">
            <ul onClick={scrollToTop}>
              <li>
                <Link to="/shop">New Arrivals</Link>
              </li>
              <li>
                <Link to="/shop">Accessories</Link>
              </li>
              <li>
                <Link to="/shop">Men</Link>
              </li>
              <li>
                <Link to="/shop">Women</Link>
              </li>
              <li>
                <Link to="/shop">Shop All</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer_content">
          <h5>Help</h5>
          <div className="links_container">
            <ul onClick={scrollToTop}>
              <li>
                <Link to="/contact">Customer Service</Link>
              </li>
              <li>
                <Link to="/loginSignUp">My Account</Link>
              </li>
              <li>
                <Link to="/contact">Find a Store</Link>
              </li>
              <li>
                <Link to="/terms">Legal & Privacy</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
              <li>
                <Link to="/">Gift Card</Link>
              </li>
            </ul>
          </div>
        </div>
         
      </div>
      <div className="container footer_bottom">
        <p>
          © {getCurrentYear()} Nevaana. All Rights Reserved | Made By{" "}
          <a
            href="nevaana.com"
            target="_blank"
            rel="noreferrer"
            style={{ color: "#C22928", textDecoration: "none" }}
          >
            Sudesh Kumar
          </a>{" "}
          with ❤️
        </p>
      </div>
    </footer>
  );
};

export default Footer;
